import { useSelector } from 'react-redux';

import useLocation from 'lib/hooks/useLocation';

import { selectCurrentUser } from 'features/auth/slice';

import {
  Heading,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

export default function UnlockProCard({
  heading = 'Take your skills to the next level',
  children,
}) {
  const currentUser = useSelector(selectCurrentUser);
  const { discount, location } = useLocation();

  if (currentUser?.hasActiveSubscription) return null;

  return (
    <div className="bg-blue-500 flex flex-col gap-4 text-white p-5 rounded-xl">
      <Heading className="font-semibold leading-snug" level="6" tagName="h2">
        {heading}
      </Heading>

      {children || (
        <ul>
          <li className="flex gap-2">
            <span aria-hidden="true">🤖</span> AI-powered solution reviews
          </li>

          <li className="flex gap-2">
            <span aria-hidden="true">⭐️</span> 50+ portfolio-ready premium
            projects
          </li>

          <li className="flex gap-2">
            <span aria-hidden="true">🎨</span> Professional Figma design files
          </li>
        </ul>
      )}

      {discount > 0 && (
        <div className="bg-blue-700 px-3 py-2 rounded-lg border border-blue-600">
          <p className="text-center">
            <span className="text-blue-100">
              Special pricing for {location?.country.name}:
            </span>{' '}
            <span className="font-bold text-white">
              Save {discount * 100}% on Pro!
            </span>{' '}
            <span aria-hidden="true">{location?.country.flag}</span>
          </p>
        </div>
      )}

      <LinkWithButtonStyles
        className="text-blue-500 w-full"
        href="/pro"
        level="tertiary"
      >
        Upgrade now
      </LinkWithButtonStyles>
    </div>
  );
}
